const initialState = () => {
    return {
        /**
         * @description
         * This variable contains data about a cash movement
         * made in sale area that it's sended to CashMovement.
         */
        typeMovement: null, //more explicative than "movement"
        movement: null,
        date: null,
        cashAmount: null,
        comment: '',
        movementType: null,
        showModal: false,

        arrayEgressType: [],
        arrayIngressType: [],
        /**
         * Después en este store o en otro, guardar ID de la caja yID del cajero:
         * pos_cash_desk_id: 0,
         * g_cashier_user_id: 1,
         */

    }
}

export default initialState
